var BASE_URL = 'https://wishlist.lightning-e.com';
var g_styleType = "custom";

function WishlistSendAPIRequestLocal( url, method, params, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( cb )
            {
                var parsed;

                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }

                cb( xhr, parsed );
            }
            else
            {

            }
        }
    };

    //console.log( "requesting " + method + " from " + url );
    if ( params )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.setRequestHeader( "x-store", window.Shopify.shop );
        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        xhr.open( method, url, true );
        xhr.send( );
    }
}

function HandleWishlistClickLocal( element )
{
    if( element.getAttribute( "data-item-wished" ) == "true" )
    {
        RemoveItemFromWishlist( element );        
    }
    else
    {
        AddItemToWishListLocal( element );
    }
}

function GetWishlistPostDataLocal( element )
{
    var wishlistData    = document.querySelector( "[data-wishlist]" ).innerHTML;
    wishlistData        = JSON.parse( wishlistData );
    payload             = wishlistData;
    payload.auth        = { "id" : wishlistData.customer.id, "email" : wishlistData.customer.email };

    if( element )
    {
        payload.productID       = element.dataset.product;
        payload.productHandle   = element.getAttribute( "data-productHandle" );
    }

    return payload;
}

function GetCustomHeaders()
{
    var customHeaders = 
    [
        { 
            "header" : "x-store", 
            "value" : wishlistConf.domain 
        }
    ];

    return customHeaders;
}

function AddItemToWishListLocal( element )
{
    var post    = GetWishlistPostDataLocal( element );
    if ( post.customer && post.customer.id && post.customer.id.length > 0 )
    {
        WishlistSendAPIRequestLocal( BASE_URL + "/api/05-09-22/wishlist-add", "POST", post, function( xhr )
        {
                if( xhr.response && xhr.response != "" )
            {
                var response = JSON.parse( xhr.response );
                if( response && response.products_count > 0 )
                {
                    if( g_styleType == "custom" )
                    {
                        WishlistCustomResponse( response, "itemAdded" );
                    }
                    else
                    {
                        //We need some default
                        // HideWishlistItems();
                        // ShowWishlistItems( response.shopify_products );
                    }
                }
            }
        } );
    }
    else
    {
        window.location.href = "/account/login"
    }
}

function RemoveItemFromWishlist( element )
{
    var post    = GetWishlistPostDataLocal( element );
    if ( post.customer && post.customer.id && post.customer.id.length > 0 )
    {
        WishlistSendAPIRequestLocal( BASE_URL + "/api/05-09-22/wishlist-remove", "POST", post, function( xhr )
        {
            var response = JSON.parse( xhr.response );
            if( response && response.products_count > 0 )
            {
                if( g_styleType == "custom" )
                {
                    WishlistCustomResponse( response, "itemRemoved" );
                    HandleFavouritedItemsIcons( response );
                }
                else
                {
                    //We need some default
                    // HideWishlistItems();
                    // ShowWishlistItems( response.shopify_products );
                }
            }
        } );
    }
    else
    {
        window.location.href = "/account/login"
    }
}

function GetWishlistItemsLocal()
{
    var post    = GetWishlistPostDataLocal();
    
    if ( post.customer && post.customer.id && post.customer.id.length > 0 )
    {
        WishlistSendAPIRequestLocal( BASE_URL + "/api/wishlist-get", "POST", post, function( xhr )
        {
            if( xhr.response && xhr.response != "" )
            {
                var response = JSON.parse( xhr.response );
                if( response && response.products_count > 0 )
                {
                    if( g_styleType == "custom" )
                    {
                        WishlistCustomResponse( response, "getAllWishlistItems" );
                    }
                    else
                    {
                        //We need some default
                        // HideWishlistItems();
                        // ShowWishlistItems( response.shopify_products );
                    }
                }
            }
        } );
    }
}

function HandleFavouritedItemsIcons( response )
{
    ClearAllWishlistIcons();
    ShowWishedControls( response );
}

function ClearAllWishlistIcons()
{
    var controlElements = document.querySelectorAll( ".lightning-wishlist-control" );
    controlElements.forEach( function( controlElement )
    {
        controlElement.setAttribute( "data-item-wished", "false" );
    } );
}

function ShowWishedControls( response )
{
    if( response.products_count > 0 )
    {
        response.shopify_products.forEach( function( shopifyProduct )
        {
            var controlElements = document.querySelectorAll( ".lightning-wishlist-control[ data-product='" + shopifyProduct.id + "' ]" );
            if( controlElements && controlElements.length > 0 )
            {
                controlElements.forEach( function( controlElement )
                {
                    controlElement.setAttribute( "data-item-wished", "true" );
                } );
            }
        } );
    } 
}

function RunWishlist()
{
    console.log( "RUNNING LOCAL WISHLIST" )
    var targets = document.querySelectorAll( ".lightning-wishlist-control" );

    targets.forEach( function( target )
    {
        target.addEventListener( "click", function( e )
        {
            e.preventDefault();
            e.stopPropagation();
            HandleWishlistClickLocal( e.currentTarget );
        } );
    } );

    GetWishlistItemsLocal();
}

var collectionPopulated = false;

function WishlistCustomResponse(response, action)
{
    console.log("/////////////////////////////////////////////////////////////////////////////////////////////////////")
    console.log(action)
    switch(action){
        case "getAllWishlistItems":
            var loadTarget = document.querySelector(".wishlist-load");

            if( loadTarget && collectionPopulated == false )
            {
                collectionPopulated = true;
                addWishlistproductsToCollection(response);
            }

            response.shopify_products.forEach(product => {
                var elements = document.querySelectorAll('[data-product="' + product.id + '"]');
                elements.forEach(element => {
                    if (element)
                    {
                        element.setAttribute("data-item-wished", "true");    
                        element.querySelector("svg").setAttribute("fill", "#000");
                    }
                });
            })
            break;
        
        case "itemAdded":
            response.shopify_products.forEach(product => {
                var elements = document.querySelectorAll('[data-product="' + product.id + '"]');
                elements.forEach(element => {
                    if (element)
                    {
                        element.setAttribute("data-item-wished", "true");    
                        element.querySelector("svg").setAttribute("fill", "#000");
                    }
                });
            })
            break;
        case "itemRemoved":
            response.shopify_products.forEach(product => {
                var elements = document.querySelectorAll('[data-product="' + product.id + '"]');
                elements.forEach(element => {
                    if (element)
                    {
                        element.setAttribute("data-item-wished", "false");    
                        element.querySelector("svg").setAttribute("fill", "transparent");
                    }
                });
            })
            break;
    }

}

function addWishlistproductsToCollection( response)
{
    var parent           = document.querySelector( ".wishlist-collection-grid" );
    var template           = document.querySelector( ".card--template" );
    var clone;
    var products = response.shopify_products;
    var product;
    var handles = [];

    products.forEach(product => {
        handles.push(product.handle)
    });
    var x = 0;

    WishlistGetShopifyProducts(products, function(response)
    {
        for(const productId in response)
        {
            product = response[productId];
            clone = template.cloneNode(true);

            populateProductCard(product.product, clone);

            parent.appendChild(clone);
            x ++;
        }
    });
    
}

function WishlistGetShopifyProducts( wishlistProductData, cb )
{
    var wishlistProducts = { };
    var asyncs           = 1;
                             
    function Done( )
    {
        asyncs--;
        if ( asyncs == 0 )
        {
            cb( wishlistProducts );
        }
    }
  // wishlistProductData= sortWishlistData(wishlistProductData);
    wishlistProductData.forEach( function( wishlistProduct )
    {
        if( !wishlistProducts[ wishlistProduct.id ] && ( wishlistProduct.handle ) && ( wishlistProduct.handle != "" ) )
        {
            asyncs++;
        
            jQuery.getJSON( "/products/" + wishlistProduct.handle + ".js", function( shopifyProduct )
            {
                wishlistProducts[ wishlistProduct.id ] = { "product" : shopifyProduct };
                // BuildWishlistPage( shopifyProduct, parent, target );
                
                Done( );
        
            } ).fail( function( xhr, status, error )
            {
                Done( );
            } );                
        }
    } );
    Done( );
}

function populateProductCard(product, card)
{
    var title = product.title;

    var price =         new Intl.NumberFormat(window.Shopify.locale + '-' + window.Shopify.country, { style: 'currency', currency: window.Shopify.currency.active }).format(
        product.price / 100,
      );

    price += " " + window.Shopify.currency.active;
    // var reducedFromPrice = product.compare_at_price / 10;
    var image = product.featured_image;
    var url = product.url;
    var vendor  = product.vendor;

    card.querySelectorAll(".card__heading a").forEach(element => {
        element.textContent = title;
        element.setAttribute("href", url);
    })

    card.querySelectorAll(".price__regular .price-item").forEach(element => {
        element.textContent = price;
    })

    // card.querySelectorAll(".price__sale .price-item").forEach(element => {
    //     element.textContent = reducedFromPrice;
    // })

    card.querySelectorAll(".media img").forEach(element => {
        element.setAttribute("src", image);
    })

    card.querySelector(".lightning-wishlist-control").setAttribute("data-item-wished", "true");
    card.querySelector(".lightning-wishlist-control svg").setAttribute("fill", "#000");

    card.classList.remove("hidden");

}

RunWishlist();